<template>
  <ls-drawer
    title="查看采购申请/采购订单"
    width="60%"
    :visible="visible"
    @close="onCancel"
    :destroy-on-close="true"
  >
    <ls-info-form :split-number="3">
      <ls-info-item title="计划单号" slot="planNo" :IsHidden="true" IsContentTip :value="billData.planNo" />
      <ls-info-item title="物料编码" slot="itemCode" :IsHidden="true" IsContentTip :value="billData.itemCode" />
      <ls-info-item title="计划数量" slot="planQuantity" :IsHidden="true" IsContentTip :value="billData.planQuantity" />
      <ls-info-item title="已推采购" :IsContentTip="true" slot="pushedPurchaseQuantity" :IsHidden="true" :value="billData.pushedPurchaseQuantity" />
      <ls-info-item title="签署数量" :IsContentTip="true" slot="signedQuantity" :IsHidden="true" :value="billData.signedQuantity" />
    </ls-info-form>
    <a-table :columns="columns" :data-source="dataSource">
      <template slot="prNumber" slot-scope="text, record">
        <div class="prNumber-box">
          <span>{{ text }}</span>
          <span>{{ record.pushPurchaseStatusName }}</span>
          <div class="column-detail" :title="record.pushPurchaseMsg">{{ record.pushPurchaseMsg }}</div>
        </div>
      </template>
      <template #userRemark="text">
        <a-tooltip :title="text">
          <div class="text-3-ellipsis">{{ text }}</div>
        </a-tooltip>
      </template>
    </a-table>
  </ls-drawer>
</template>

<script>
import { getPurchasePlanPoolOrderApi } from '@/api/scp/month-plan-pool/month-plan-pool';
export default {
  name: 'PurchaseOrderDrawer',
  data () {
    return {
      visible: false,
      billData: {},
      dataSource: [],
      columns: [
        {
          title: '采购申请号',
          dataIndex: 'prNumber',
          scopedSlots: { customRender: 'prNumber' },
          width: 150
        },
        {
          title: '采购订单号',
          dataIndex: 'purchaseBillCode',
          width: 150
        },
        {
          title: '采购单行状态',
          dataIndex: 'billStatusStr',
          customRender: (text) => <ls-tags color="#2b49b0">{text}</ls-tags>,
          width: 96
        },
        {
          title: '签署状态',
          dataIndex: 'contractStatusStr',
          customRender: (text) => <ls-tags color="#3d7a4f">{text}</ls-tags>,
          width: 96
        },
        {
          title: '采购数量',
          dataIndex: 'quantity',
          width: 80
        },
        {
          title: '双方确认交期',
          dataIndex: 'ensureDeliveryTime',
          width: 96
        },
        {
          title: '计划交货日期',
          dataIndex: 'planDeliveryTime',
          width: 90
        },
        {
          title: '备注',
          dataIndex: 'userRemark',
          scopedSlots: { customRender: 'userRemark' }
        }
      ]
    }
  },
  methods: {
    async show (record) {
      this.visible = true
      this.billData = record;
      this.getPurchasePlanPoolOrder()
    },
    onCancel () {
      this.billData = {};
      this.visible = false
    },
    async getPurchasePlanPoolOrder () {
      const res = await getPurchasePlanPoolOrderApi({ id: this.billData.id });
      if (res.code === 200) {
        this.dataSource = res.data?.purchaseDetailVOList || [];
      }
    }
  }
}
</script>
<style scoped lang="less">
.text-3-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
.prNumber-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .column-detail {
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
</style>
